import { update } from 'lodash';
import { API, message } from '../../modules/api';
import { CONFIG } from '../../modules/config';
import { ACTIVITY_DOM } from '../../modules/dom';
import { UTILS } from '../../modules/utils';
import ChatMessageItem from './components/ChatMessageItem.vue';

const DeepSeekDom = {   
  updateChatListDom(topClass) {   
    let topDom = document.getElementsByClassName(topClass)[0];
    let boxDom = document.getElementsByClassName('deep-seek-pp-content')[0];
    console.log('updateChatListDom----', boxDom, topDom);
    if(boxDom && topDom) {
      boxDom.style.height = innerHeight-topDom.clientHeight+'px';
    }
    let bottomDom = document.getElementsByClassName('deep-seek-pp-bottom')[0];
    let noteDom = document.getElementsByClassName('deep-seek-pp-list-note-bottom')[0];
    let height = boxDom ? boxDom.clientHeight : window.innerHeight; 
        height = bottomDom ? height - bottomDom.clientHeight : height;
        height = noteDom ? height - noteDom.clientHeight : height;
    console.log('updateChatListDom----', bottomDom, noteDom, height);
    let listDom = document.getElementById('ChatContentVirtualList');
    if(listDom) {
      listDom.scrollTop = listDom.scrollHeight;
      listDom.style.transition = 'all 0.5s';
      listDom.style.height = height+'px';
    }
  }
};
// plugins/deepseek/index.js
const DeepSeekPlugin = {
    install(Vue, options) {
      const config = {
        store: null,
        ...options
      };

      // 创建响应式状态管理
      const state = Vue.observable({
        isVisible: false,
        isPopupVisible: false,
        dsParams: null,
        dsInfo: null,
        dsMinId: -1,
        dsMsgList: [],
        gotAskList: false,
        curDsMsgData: {ask: '', content: '', f_time: '', id: '', reasoning_content: '' },
        dsMsgListUpdating: false,
        gotProductList: false,
        dsProductList: [],
      });

      // 注册全局组件: 深度解盘弹窗
      Vue.component('deep-seek-popup', {
        components: { ChatMessageItem },
        computed: {
          visible: {
            get() {
              return state.isVisible;
            },
            set(value) {
              state.isVisible = value;
            }
          },
          dsParams() {
            return state.dsParams;
          },
          showLoading() {
            return state.dsMsgListUpdating;
          },
          dsFreeUsage: {
            get() {
              return state.dsInfo ? state.dsInfo.free_usage+state.dsInfo.extra_usage : 0;;
            },
            set(value) {
              if(state.dsInfo.extra_usage) {
                state.dsInfo.extra_usage = value;
              }else {
                state.dsInfo.free_usage = value;
              }
            }
          },
          dsFirstSend() {
            return state.dsInfo ? state.dsInfo.firstSend : false;  
          },
          dsMsgList() {
            return state.dsMsgList.slice().sort((a, b) => a.f_time - b.f_time).map(msg => {
              if (!msg.ask) {
                msg.ask = this.defaultAsk;
              }
              return msg;
            });
          }
        },
        watch: {
          dsFirstSend: {
            handler: function (val) {
              console.log('dsFirstSend---watch----', val);
              if(val) {
                this.triggerSendAskMsg(this.defaultAsk);
              }
            }
          },
          dsMsgList: {
            handler: function (val) {
              this.textStr = "";
              // if (this.$refs.dsvsl) {
              //   setTimeout(() => {
              //     this.$refs.dsvsl.scrollToBottom();
              //   }, 300);
              // }
              setTimeout(() => {
                  const listDom = document.getElementById('ChatContentVirtualList');
                  if (listDom) {
                    listDom.scrollTop = listDom.scrollHeight+50; // 直接设置 scrollTop
                  }
                }, 50);
              if (state.dsMinId === 0 || this.dsGotMsgListAll) {
                this.dsGotMsgListAll = true;
                this.canSend = false;
                return;
              }
              this.dsGotMsgListAll = val[0].id === state.dsMinId ? true : false;
              this.canSend = false;
              console.log('dsMsgList--watch----', val, state.dsMinId, this.dsGotMsgListAll);
            },
            deep: true
          }
        },
        data() {
          return {
            textStr: '',
            defaultAsk: '综合分析',
            payMsg: '免费体验次数已用完，请开通终身会员。解锁 DeepSeek 辅助解读功能。',
            canSend: false,
            showHistory: false,
            askList: [],
            dsMsgListRefreshing: false,
            dsGotMsgListAll: false,
            itemComponent: ChatMessageItem,
            chatURL: 'https://ws.yxdxt.com:7273/chatAiStream',
            showPPTips: false,
          };
        },
        methods: {
          clickClose() {
            this.visible = false;
            this.showPPTips = false;
            this.showHistory = false;
            // 重置一些数据
            state.gotAskList = false;
          },
          clickPopup() {
            console.log('clickPopup----')
            this.showPPTips = true;
          },
          clickContent() {
            console.log('clickContent----')
            this.showHistory = false;
          },
          clickReadAll() {
            console.log('clickReadAll----一键解读', state.dsParams)
            this.showHistory = true;
            if(state.gotAskList) {
              return;
            } 
            API.getDSAskList({hid: state.dsParams.id}, (res)=>{
              console.log('getDSAskList---', res);
              state.gotAskList = true;
              this.askList = res;
            });
          },
          focusTextArea() {

          },
          blurTextArea() {

          },
          clickItem(item) {
            if(this.dsFreeUsage <= 0) {
              if(config.store.state.userData.vip === 30) { 
                this.getDSProductList();
                return;
              }
              this.$toast({
                message: this.payMsg,
                className: 'van-toast--width-80',
              });
              this.$store.state.user.showActDayLuckPop = true;
              setTimeout(() => {
                  ACTIVITY_DOM.updateActivityDayLuckDom();
              }, 100);
              return;
            }
            this.triggerSendAskMsg(item.ask);
            this.showHistory = false;
          },
          clickSend() {
            if(this.textStr === '') {
              this.$toast('请输入内容');
              return;
            }
            if(this.dsFreeUsage <= 0) {
              console.log('check----vip----', config.store.state.userData.vip);
              if(config.store.state.userData.vip === 30) { 
                this.getDSProductList();
                return;
              }
              this.$toast({
                message: this.payMsg,
                className: 'van-toast--width-80',
              });
              this.$store.state.user.showActDayLuckPop = true;
              setTimeout(() => {
                  ACTIVITY_DOM.updateActivityDayLuckDom();
              }, 100);
              return;
            }
            this.triggerSendAskMsg(this.textStr);
            this.textStr = '';
            this.canSend = false;
          },
          triggerSendAskMsg(ask) {
            // 上一段数据正在输出中
            if(state.dsMsgListUpdating) {
              return;
            }
            state.dsMsgListUpdating = true;
            state.curDsMsgData.ask = ask;
            state.curDsMsgData.f_time = parseInt(Date.now()/1000)-1;
            state.dsMsgList.push(state.curDsMsgData);
            this.dsFreeUsage--;
            setTimeout(() => {
              DeepSeekDom.updateChatListDom(this.dsParams.topClass); 
            }, 20);
            
            // 发送消息
            ask = ask == this.defaultAsk ? '' : ask;
            let apiParams = Object.assign({ id: state.dsParams.id, from: 1, ask: ask }, CONFIG.platform_params);
                apiParams = Object.assign({ token: config.store.state.userData.token }, apiParams);
            console.log('triggerSendAskMsg----', apiParams);
            let url = `${this.chatURL}?${UTILS.convertParamsToUrl(apiParams)}`;
            console.log('triggerSendAskMsg----', url);
            this.fetchStreamData(url);
          },
          async fetchStreamData(url, offset = 0) {
            if (url === '') {
              console.error('fetchStreamData---url不能为空', state.dsParams);
              return;
            }
            try {
              const response = await fetch(`${url}&offset=${offset}`);
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              const reader = response.body.getReader();
              const decoder = new TextDecoder();
              let result = '';
              while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                result += decoder.decode(value, { stream: true });
                // 处理流式数据
                this.updateMsgList(result);
                offset += value.length; // 更新偏移量
              }
              console.log('Fetch complete');
              // 重置数据
              state.dsMsgListUpdating = false;
              state.curDsMsgData = { ask: '', content: '', f_time: '', id: '', reasoning_content: '' };
              setTimeout(() => {
                DeepSeekDom.updateChatListDom(this.dsParams.topClass); 
              }, 20);
            } catch (error) {
              console.error('Fetch error:', error);
              // 在请求失败时重试
              setTimeout(() => {
                console.log('Retrying fetchStreamData...');
                this.fetchStreamData(url, offset); // 继续从上次中断的地方恢复
              }, 3000); // 延迟 3 秒后重试
            }
          },
          updateMsgList(str) {  
            let dataArray = str.split('}{').map((item, index, arr) => {
              if (index === 0) return arr.length == 1 ? item : item + '}';
              if (index === arr.length - 1) return '{' + item;
              return '{' + item + '}';
            }).map(item => {
              try {
                return JSON.parse(item);
              } catch (e) {
                console.error('JSON parse error:', e, item);
                return null;
              }
            }).filter(item => item !== null);
            let reasoningString = dataArray.map(item => item.reasoning_content).join('');
            let contentString = dataArray.map(item => item.content).join('');
            state.curDsMsgData.content = contentString;
            state.curDsMsgData.reasoning_content = reasoningString;
            state.dsMsgList[state.dsMsgList.length - 1] = state.curDsMsgData;
            // console.log('updateMsgList---', state.curDsMsgData, state.dsMsgList);
          },
          onScrollToTop() {      
            console.log('onScrollToTop----', this.dsGotMsgListAll);
            this.dsMsgListRefreshing = true;
            setTimeout(() => {
              this.dsMsgListRefreshing = false;
              if(this.dsGotMsgListAll) {
                return;
              }
              // 更新消息记录数据
              API.getDSMsgList({hid: state.dsParams.id, minId: state.dsMinId}, (res)=>{
                console.log('getDSMsgList---', res);
                state.dsMinId = res.minId; 
                state.dsMsgList = res.list.concat(state.dsMsgList);
              });
            }, 1000);
          },
          adjustTextareaHeight(event) {
            this.canSend = this.textStr.length > 0;
            const textarea = event.target;
            textarea.style.height = 'auto';
            const lineHeight = 26; // 假设每行高度为24px
            const maxLines = 4;
            let lines = textarea.value.split('\n').length;
                lines = lines+parseInt(this.textStr.length/22);
            let newHeight = Math.min(lines, maxLines) * lineHeight;
                newHeight = newHeight < 48 ? 48 : newHeight;
            // console.log('adjustTextareaHeight---', lines, this.textStr.length, newHeight);
            textarea.style.height = `${newHeight}px`;
            textarea.style.overflowY = lines > maxLines ? 'scroll' : 'hidden';
          },
          getDSProductList() {  
            if(state.gotProductList) {
              state.isPopupVisible = true;
              return;
            }
            API.getProductList({type: 13}, (res)=>{
              state.isPopupVisible = true;
              state.gotProductList = true;
              state.dsProductList = res.map(product => ({
                ...product,
                price: product.price / 100,
                rate_price: product.rate_price / 100
              }));
              console.log('getDSProductList---', state.dsProductList);
            });
          }
        },
        template: `
          <div v-if="visible" class="deep-seek-popup" @click.stop="clickPopup">
              <!-- 弹窗内容 -->
              <div class="deep-seek-pp-content" @click.stop="clickContent">
                  <div v-if="showPPTips" class="deep-seek-tips tips-3"></div>
                  <div class="deep-seek-pp-close" @click.stop="clickClose"></div>
                  <div class="deep-seek-pp-main-content">
                      <div class="deep-seek-pp-msg-content-box">
                          <virtual-list
                              ref="dsvsl"
                              id="ChatContentVirtualList"
                              class="overflow-y-scroll scroll-touch"
                              :data-key="'id'"
                              :data-sources="dsMsgList"
                              :data-component="itemComponent"
                              :estimate-size="2"
                              :header-class="'deep-seek-pp-list-note'"
                              v-on:totop="onScrollToTop">
                              <div v-show="true" slot="title" class="deep-seek-pp-main-title">
                                  <p class="title1">众所周知DeepSeek排盘准确性有限，天时子平准确排盘与 DS 强强联合为您准确解盘保驾护航!</p>
                                  <p class="title2">注：DS解盘准确性有限，辅助参考，天时子平自有AI更准确</p>
                              </div>
                              <div v-show="dsMsgListRefreshing" slot="header" class="lds-dual-ring lds-dual-ring-gray"></div>
                          </virtual-list>
                          <div v-if="showLoading" class="deep-seek-pp-list-note-bottom">
                            <div class="deep-seek-pp-message-loading"></div>
                          </div>
                      </div>
                      <div class="deep-seek-pp-bottom">
                          <button class="deep-seek-pp-btn-read" @click.stop="clickReadAll"></button>
                          <div class="deep-seek-pp-form dsp-flex">
                              <div class="deep-seek-pp-textarea-box">
                                  <textarea class="deep-seek-pp-textarea" @focus="focusTextArea" @blur="blurTextArea" @input="adjustTextareaHeight" v-model="textStr" name="base" id="" cols="30" rows="4" maxlength="200" placeholder="给 DeepSeek 发送消息"></textarea>
                              </div>
                              <div class="deep-seek-pp-form-btn-box">
                                  <button class="deep-seek-pp-btn-send" :class="{ 'disabled': !canSend }" @click.stop="clickSend">
                                      <p class="note">{{ dsFreeUsage }}次/月</p>
                                  </button>
                              </div>
                          </div>
                          <div class="deep-seek-pp-sub-note">
                            <p>内容由DeepSeek AI生成，不构成任何建议，仅供参考</p>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- 历史记录 -->
              <div v-if="showHistory" class="deep-seek-history-list">
                  <div class="deep-seek-hl-msg-content">
                      <div class="deep-seek-hl-msg-item" v-for="(item, index) in askList" :key="index" @click.stop="clickItem(item)">
                          <p>{{ item.ask }}</p><p><i class="iconfont icon-xiangyou"></i></p>
                      </div>
                  </div>
              </div>
          </div>
        `
      });

      // 注册全局组件: 深度解盘支付弹窗
      Vue.component('deep-seek-pay-popup', { 
        computed: {
          visible: {
            get() {
              return state.isPopupVisible;
            },
            set(value) {
              state.isPopupVisible = value;
            }
          },
          dsVipFree() {
            return state.dsInfo ? state.dsInfo.vipFree : 0;  
          },
          curProductData() {
            return state.dsProductList[0] || {};
          }
        },
        methods: {
          clickPay() {
            console.log('clickPay----');
            this.visible = false;
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: this.curProductData.pid,
                    ptype: this.curProductData.payType[2],
                    discount: CONFIG.vip_discount
                },
                // mixParams: {
                //     pid: pData.pid,
                //     product_name: pData.title,
                //     price: pData.price,
                //     from: 'pop_998',
                // },
                sucCb: function() {
                    console.log('购买流量包成功');
                    // 更新数据
                    API.getDSInfo({hid: state.dsParams.id}, (res)=>{
                      console.log('getDSInfo---', res);
                      state.dsInfo = res;
                    });
                },
                failCb: ()=> {
                    console.error('支付失败----')
                }
            });
          }
        },
        template: `
          <van-popup :value="visible" class="deep-seek-pay-popup" position="bottom">
              <!-- 弹窗内容 -->
              <div class="deep-seek-pay-pp-content">
                <div class="deep-seek-pay-pp-close" @click.stop="visible = false"><i class="iconfont icon-close"></i></div>
                <div class="deep-seek-pay-pp-main-content">
                  <div class="deep-seek-pay-pp-title">
                    <p class="title1">购买流量包</p>
                    <p class="title2">终身会员每月赠送的{{ dsVipFree }}次提问已用完，可以购买额外次数</p>
                  </div>
                  <div class="deep-seek-pay-pp-main">
                    <p class="price">￥<span>{{ curProductData.rate_price }}</span></p>
                    <p class="note">{{ curProductData.num }}次提问</p>
                  </div>
                  <div class="deep-seek-pay-pp-bottom">
                    <button class="deep-seek-pay-pp-btn" @click.stop="clickPay">马上购买</button> 
                  </div> 
                </div> 
              </div>
          </van-popup>
        `
      });

      // 添加实例方法
      Vue.prototype.$showDeepSeek = (params) => {
        console.log('params----', params, this);
        state.dsParams = params;
        state.isVisible = true;
        // 获取DS信息
        API.getDSInfo({hid: params.id}, (res)=>{
          console.log('getDSInfo---', res);
          setTimeout(() => {
            state.dsInfo = res;
          }, 200);
        });
        // 获取DS消息列表
        API.getDSMsgList({hid: params.id}, (res)=>{
          console.log('getDSMsgList---', res);
          state.dsMinId = res.minId;
          state.dsMsgList = res.list;
          DeepSeekDom.updateChatListDom(params.topClass); 
        });
        state.dsMsgListUpdating = false;
        state.curDsMsgData = {ask: '', content: '', f_time: '', id: '', reasoning_content: ''};
      };
  
    }
};


export default DeepSeekPlugin;